import Vue from "vue";
import Repository from '@/repositories/marketing'
import Unification from '@/repositories/unification'
import Axios from 'axios'
import config from '@/config'
import store from '../store'
import $identity from '@/repositories/identity'
import { refreshToken, keycloakObj,mergeObjects } from '@core/config/utils'
const resource = '/users'
const identityResource = `session/preferences`

export default {
    getRoles (config) {
        return Repository.get(`${resource}/roles.json`, config)
    },
    getAccountInfo(config){
        return Repository.get(`show.json`, config)
    },
    getAccountList (config) {
        return Repository.get(`${resource}/account_list.json`, config)
    },
    getPackageFeatures (config) {
        return Repository.get('/package_features.json', config)
    },
    async getPreferences (config) {
        await refreshToken();
        let preferences = await Vue.prototype.$keycloak.loadUserProfile();
        if(preferences.attributes && preferences.attributes.preferences && preferences.attributes.preferences[0]){
            return JSON.parse(preferences.attributes.preferences[0])
        }
    },
    getSelectedUsers (config) {
        return Repository.get(`${resource}.json`, config)
    },
    async savePreferences (data, config) {
        await refreshToken();
        let preferences = await  Vue.prototype.$keycloak.loadUserProfile();
        if(!preferences.attributes)
            preferences.attributes = {}
        if(!preferences.attributes.preferences)
            preferences.attributes.preferences = ["{}"]
        data = mergeObjects(JSON.parse(preferences.attributes.preferences[0]),data)
        preferences.attributes.preferences[0] = JSON.stringify(data) 
        const keysToRemove = ["userProfileMetadata", "phoneNumber", "id", "emailVerified", "companyName"];
        keysToRemove.forEach((key) => delete preferences[key]);
        const { baseURL } = keycloakObj()
        await refreshToken();
        return $identity.post("account", preferences, { baseURL,withCredentials: true });
    },
    toggleFolder (config) {
        return Repository.get(`${resource}/toggle_folders.json`, config)
    },
    getChannelSignature (config) {
        return Repository.get('/channel_signature.json', config)
    },
    getAllAccountList (config) {
        return Unification.get(`accounts.json`, config)
    },
    async getInfo(params) {
        const LoginAxios = Axios.create();
        const keycloak = Vue.prototype.$keycloak;
        await refreshToken();
        let timeZone = store.state.auth ? store.state.auth.preferences ? store.state.auth.preferences.time_zone : store.state.auth.preferences.time_zone : 'America/New_York' ;
        return LoginAxios.get(`${resource}/info.json`, {
          baseURL: `${config.RAILS_BASE_URL}/v2`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "MP-ID-TOKEN": 'Bearer ' + keycloak.token,
            "Authorization": 'Bearer ' + keycloak.token,
            "TZ" : timeZone
          },
          withCredentials: true
        });
    }
}
